import React from 'react';
import { Marker as VisGlMarker } from '@vis.gl/react-google-maps';
const toGoogleIcon = (icon) => {
    if (!icon)
        return undefined;
    if (typeof icon === 'string')
        return icon;
    const result = { url: icon.url };
    if (icon.scaledSize) {
        result.scaledSize = new google.maps.Size(icon.scaledSize.width, icon.scaledSize.height);
    }
    return result;
};
export const Marker = ({ position, icon, title, draggable, animation, onClick, onMouseOver, onMouseOut, onDrag, children, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(VisGlMarker, { position: position, icon: toGoogleIcon(icon), title: title, draggable: draggable, animation: animation, clickable: Boolean(onClick || onMouseOver || onMouseOut), onClick: onClick, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onDrag: onDrag }),
        children));
};
